const requiredVariables = [];
const defaults = {
  APP_ENV: 'dev',
};

const DATA_ATTR_NAME = 'data-env';

export function flushRequiredVariables() {
  const envelope = requiredVariables.slice(0);
  requiredVariables.length = 0;
  return envelope;
}

export function getEnv(name) {
  const target = process.env.BROWSER_RUNTIME
    ? JSON.parse(window.document.documentElement.getAttribute(DATA_ATTR_NAME) || '{}')
    : process.env;

  const value = target[name];

  if (!~requiredVariables.indexOf(name)) {
    requiredVariables.push(name);
  }

  return value || defaults[name];
}

export function resolve(config) {
  const defaultEnv = '*';
  const currentEnv = getEnv('APP_ENV');

  if (!config) return config;
  if (currentEnv in config) return config[currentEnv];
  if (defaultEnv in config) return config[defaultEnv];
  return undefined;
}

export function toHTMLAttribute(names) {
  const dictionary = toDictionary(names);
  return `${DATA_ATTR_NAME}='${JSON.stringify(dictionary)}'`;
}

export function toDictionary(names) {
  return []
    .concat(names || [])
    .reduce((result, name) => {
      result[name] = getEnv(name);
      return result;
    }, {});
}
